import * as utils from "../../Utilities";
import './miniAssessment.css';
import * as aserver from '../../APIClient';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useEffect, useState } from "react";
import WhiteLogo from "../images/AIM Leaf Inverted.png"
const axios = require('axios').default;

const RegInput = (props) => {
  return(
    <div>
    <label htmlFor={props.field}>{props.title}</label>
    <input type="text" name={props.field} id={props.field} value={props.data[props.field]} onChange={()=>{}} required />
    </div>
  )
}

const Waiting = (props) => {
  return(
    <div>
      ...
    </div>
  )
}

const MiniAssessment = (props) => {

  const serviceName = 'blink';
  const startAssessmentButtonText = 'Start Assessment';

  const pathname = window.location.pathname;
  const coachUUID = pathname.split('/').pop();
  const localStorageKey = `assessment_state_${coachUUID}`;

  const Page = Object.freeze({
    LanguageSelection: 'pLanguageSelection',
    Registration: 'pRegistration',
    Questions: 'pQuestions',
    Results: 'pResults',
    Error: 'pError'
  });

  const [language, setLanguage] = useState('english');
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [page, setPage] = useState(Page.LanguageSelection);
  const [questions, setQuestions] = useState(null);
  const [questionNumber, setQuestionNumber] = useState(null);
  const [coach, setCoach] = useState(null);
  const [assessmentID, setAssessmentID] = useState(null);
  const [responses, setResponses] = useState({});
  const [results, setResults] = useState({});
  const [waiting, setWaiting] = useState(false);
  const [translations, setTranslations] = useState(null);
  const [registrationData, setRegistrationData] = useState({
    name: "",
    surname: "",
    email: ""
  });

  function atranslate(string) {
    let translation = string;
    if (language!=='english') {
      translation = translations[language][string]??'?'+string+'?'
    }
    if (questionNumber)
      translation = translation.replaceAll('<questionNumber>',questionNumber);
    if (coach)
      translation = translation.replaceAll('<coachName>',coach.displayName);
    if (string!=startAssessmentButtonText)
      translation = translation.replaceAll('<startAssessment>', atranslate(startAssessmentButtonText));
    return(translation);
  }

  function getGeneralTerms() {
    let s = atranslate('By clicking on "<startAssessment>", you agree to our `general terms`.');
    s = s.replace("`", `<a href="https://aephoriagroup.com/general-terms/" target="_blank" rel="noreferrer">`);
    s = s.replace("`", "</a>")
    return(s);    
  }

  function saveState() {
    let state = JSON.stringify({
      language: language,
      page: page,
      questions: questions,
      questionNumber: questionNumber,
      coach: coach,
      assessmentID: assessmentID,
      responses: responses,
      results: results,
      registrationData: registrationData
    });
    window.localStorage.setItem(localStorageKey, state)
  }

  function loadState() {
    try {
      let state = window.localStorage.getItem(localStorageKey);
      if (state !== null) {
        state = JSON.parse(state);
        setLanguage(state.language);
        setPage(state.page);
        setQuestions(state.questions);
        setQuestionNumber(state.questionNumber);
        setCoach(state.coach);
        setAssessmentID(state.assessmentID);
        setResponses(state.responses);
        setResults(state.results);
        setRegistrationData(state.registrationData);
        if (state.page===Page.Error) {
          clearState();
          setPage(Page.LanguageSelection);        
        }
      }
    } catch (err) {
      setPage(Page.LanguageSelection);
    }
  }

  function clearState() {
    setSelectedLanguage(null);
    window.localStorage.removeItem(localStorageKey)
  }

  useEffect(() => {
    async function getTranslations() {
      try {
        let options = {};
        options.headers = { 'x-blink-access': 'secret' };
        setWaiting(true);
        const response = await axios.get(`${aserver.getServerRoot()}/mintor/initAssessment`, options);
        setTranslations(response.data.translations);
        setWaiting(false);
      } catch (err) {
      }
    };
    loadState();
    getTranslations();
  },[])

  useEffect(() => {
    saveState();
  })

  async function postData(endpoint, data) {
    try {
      let options = {};
      options.headers = { 'x-blink-access': 'secret' };
      //console.log('POSTING to',endpoint);
      setWaiting(true);
      const response = await axios.post(`${aserver.getServerRoot()}/mintor/${endpoint}`, data, options);
      setWaiting(false);
      //console.log('RESPONSE');
      //console.log(JSON.stringify(response.data,null,2));
      return(response);
    } catch (err) {
      console.log(err);
      console.log(err.data);
      changePage(Page.Error);
      return({data: {}});
    }
  }

  async function startAssessment() {
    let data = {
      localLanguage: language,
      registrationData: registrationData,
      service: serviceName,
      coachUUID: coachUUID
    }
    let response = await postData('startAssessment', data)
    setQuestions(response.data);
    setCoach(response.data.coach);
    setAssessmentID(response.data.uniqueId);
    setQuestionNumber(1);
    changePage(Page.Questions);
  }

  async function section1Completed() {
    let data = {...responses, uniqueId: assessmentID};
    let response = await postData('section1Completed', data);
    setQuestions(response.data);
    setResponses({});
  }

  async function section2Completed() {
    let data = {...responses, uniqueId: assessmentID};
    let response = await postData('section2Completed', data);
    setResults(response.data);
    changePage(Page.Results);
  }


  async function nextQuestion() {
    if (questionNumber === 3) {
      section1Completed();
    }
    if (questionNumber ===4) {
      section2Completed();
      return;
    }
    setQuestionNumber(questionNumber+1);
  }

  async function changePage(newPage) {
    setPage(newPage);
  }

  async function startAgain() {
    clearState();
    setPage(Page.LanguageSelection);
  }

  const handleResponseInputChange = (event) => {
    if (event.target.nodeName === 'INPUT') {
      let r = { ...responses };
      r[event.target.name] = event.target.value;
      setResponses(r)
    }
  }

  const handleLanguageChange = (event) => {
    if (event.target.nodeName === 'INPUT') {
      setLanguage(event.target.value);
      setSelectedLanguage(event.target.value);
    }
  }

  const handleRegistrationDataChange = (event) => {
    if (event.target.nodeName === 'INPUT') {
      let rdata = { ...registrationData };
      rdata[event.target.name] = event.target.value;
      setRegistrationData(rdata)
    }
  }

  function allRegistrationDataValid() {
    let {name,surname,email} = registrationData;
    let isEmailValid = utils.validateEmail(email)
    if (name&&surname&&isEmailValid)
      return(true);
    return(false);
  }

  if (!translations) {
    return(<Waiting/>);
  }

  return (<div className='maContainer'>
    <CssBaseline />
    <div className="Header">
      <img className="aephoria-logo" src={WhiteLogo} alt="aephoria-logo"/>
      <h2>{atranslate('Mini-Assessment')}</h2>
    </div>
    {(!waiting)?<div className="body">
    {page === Page.LanguageSelection &&
      <>
      <div className="miniAssesmentModal">

        <h3 className="heading">{atranslate('Language Selection')}</h3>
        <div>
          {atranslate('Welcome to the Aephoria Mini-Assessment - it will just take a few minutes of your time.')}
          <br></br>
          <br></br>
          {atranslate('Please select a language:')}
          <br></br>
          <br></br>
        </div>
        <div onChange={handleLanguageChange}>
          {aserver.Languages.sort().filter(lang=>['english','slovak','hungarian'].includes(lang)).map((language,index)=>{
            let id = `language_${language}`;
            return(<div key={index}>
              <input type="radio" id={id} name='language' value={language} />
              <label htmlFor={id}>{utils.capitalize(language)}</label>
              <br></br>
              <br></br>
            </div>)
            })}
        </div>

        <div className="navButtons">
          <Button disabled={waiting||!selectedLanguage} variant="contained" color="primary" onClick={() => changePage(Page.Registration)}>{atranslate('Continue')}</Button>
        </div>
      </div>

      </>
    }

    {page === Page.Registration &&
      <>
      <div className="miniAssesmentModal">
          <h3 className="heading">{atranslate('Registration')}</h3>

          <div onChange={handleRegistrationDataChange}>
            <RegInput title={atranslate('Name')} field='name' data={registrationData}/>
            <br></br>
            <RegInput title={atranslate('Surname')} field='surname' data={registrationData}/>
            <br></br>
            <RegInput title={atranslate('Email')} field='email' data={registrationData}/>
            <br></br>
          </div>

          <div className="navButtons">
            <Button variant="contained" color="primary" onClick={() => changePage(Page.LanguageSelection)}>{atranslate('Back')}</Button>
            <Button disabled={waiting||!allRegistrationDataValid()} variant="contained" color="primary" onClick={() => startAssessment()}>{atranslate('Start Assessment')}</Button>
            <p dangerouslySetInnerHTML={{ __html: getGeneralTerms() }}></p>
          </div>
        </div>
      </>
    }

    {page === Page.Questions &&
      <>
        <div className="miniAssesmentModal">
          <h3 className="heading">{atranslate('Question <questionNumber> of 4')}</h3>
          <div>
          {questions['q'+questionNumber]}
          <br></br>
          <br></br>
          <div onChange={handleResponseInputChange}>
            {['A','B','C'].map((response,index)=>{
              let id = `q${questionNumber}r${response}`;
              return(<div className="questionDiv" key={questionNumber*10+index}>
                <input type="radio" id={id} name={`q${questionNumber}`} value={response} />
                <label htmlFor={id}>{questions['q'+questionNumber+response]}</label>
                <br></br>
                <br></br>
              </div>)
            })}
          </div>
          </div>
          <div className="navButtons">
            <Button disabled={responses[`q${questionNumber}`]?waiting:true} variant="contained" color="primary" onClick={() => nextQuestion()}>{atranslate('Submit')}</Button>
          </div>
        </div>
      </>
    }

    {page === Page.Results &&
      <>
        <div className="miniAssesmentModal">
          <h3 className="heading">{atranslate('Results')}</h3>
          <div>
            {atranslate('All done, thank you. Here are your results.')}
            <br></br>
            <br></br>
            <b>
            {results.enneaTitle}
            </b>
            <br></br>
            <br></br>
            {results.resultText}
            <br></br>
            <br></br>
            {/*atranslate('Please contact <coachName> if you want to know more.')*/}
            <br></br>
            <br></br>
            {/*<Button variant="contained" color="primary" onClick={() => startAgain()}>Start again (only for testing, not in final version)</Button>*/}
          </div>
        </div>
      </>
    }

    {page === Page.Error &&
      <>
        <h3 className="heading">{atranslate('An error has occurred')}</h3>
      </>
    }
    </div>:<Waiting/>}
  </div>)
};

export default MiniAssessment;

